// extracted by mini-css-extract-plugin
export default {"emojiButton":"emojiPickerButton_emojiButton__8DC3+","emojiMenu":"emojiPickerButton_emojiMenu__ACf18"};